export default __webpack_public_path__ + "static/media/confidental.f2219806.svg";